module.exports = "\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/system-level-setting/adminManagement/adminManagement.component.html
// module id = 1281
// module chunks = 10